module.exports = __webpack_public_path__ + "static/beast-705420e3e62991d0de11c95f63ff1117.png";